export const NOTIFICATIONS_SHEET_PAPER_PROPS = {
  sx: {
    width: '100vw',
    overflow: 'hidden',
  },
};
